var _defs, _path, _path2, _path3, _path4, _g, _g2, _g3, _path5, _path6, _g4, _g5, _path7, _g6, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyStatesIllustrationError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 267.491,
    height: 226.748,
    viewBox: "0 0 267.491 226.748",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:url(#a);}.b{fill:#029ce0;}.c{fill:#fff;}.d{fill:#ff6584;}.e{fill:#b3b2d8;}.f{fill:#8282bc;}.g{fill:url(#b);}.h{fill:url(#c);}.i{fill:url(#d);}.j{fill:url(#e);}.k{fill:url(#f);}.l{fill:url(#g);}.m{fill:url(#i);}.n{fill:url(#j);}.o{fill:url(#k);}.p{fill:url(#l);}.q{fill:url(#m);}.r{fill:url(#n);}.s{fill:#f2f2f2;}.t{fill:url(#o);}.u{fill:url(#p);}.v{fill:url(#q);}.w,.y{fill:#c8d3d7;}.w{opacity:0.31;}.x{opacity:0.15;}.y{opacity:0.57;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0.058,
    y1: 0.372,
    x2: 1.008,
    y2: 0.724,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f5f9fd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.155,
    stopColor: "#e7eef8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.444,
    stopColor: "#d2ddf0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.728,
    stopColor: "#c5d3ec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c1d0ea"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: -0.12,
    y1: 0.122,
    x2: 1.126,
    y2: 0.882,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.857,
    stopColor: "#b7c7de"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.972,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: -0.049,
    y1: 0.161,
    x2: 1.193,
    y2: 0.928,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b7c7de"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 0.149,
    y1: 0.251,
    x2: 0.939,
    y2: 0.842,
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.028,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b7c7de"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: -0.114,
    y1: 0.174,
    x2: 1.196,
    y2: 0.87,
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 0.13,
    y1: 0.234,
    x2: 0.918,
    y2: 0.83,
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: 0.01,
    y1: 0.444,
    x2: 0.999,
    y2: 0.568,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.729,
    stopColor: "#b7c7de"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: 0.006,
    y1: 0.44,
    x2: 0.999,
    y2: 0.586,
    xlinkHref: "#i"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    x1: 0.009,
    y1: 0.562,
    x2: 1.002,
    y2: 0.458,
    xlinkHref: "#i"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    x1: 0.176,
    y1: 0.167,
    x2: 0.892,
    y2: 0.943,
    xlinkHref: "#i"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    x1: 0.345,
    y1: 0.107,
    x2: 0.612,
    y2: 0.965,
    xlinkHref: "#i"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "n",
    x1: 0.163,
    y1: 0.015,
    x2: 0.762,
    y2: 0.738,
    xlinkHref: "#i"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "o",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "p",
    x1: -0.064,
    y1: 0.525,
    x2: 1.015,
    y2: 0.525,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#e4eaf2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.387,
    stopColor: "#cbd7e7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578,
    stopColor: "#bccbe0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734,
    stopColor: "#b7c7de"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.792,
    stopColor: "#bccbe0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859,
    stopColor: "#c9d5e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.929,
    stopColor: "#e0e7f1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "q",
    x1: -0.138,
    y1: 0.525,
    x2: 1.079,
    y2: 0.525,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.372,
    stopColor: "#c1d0ea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.704,
    stopColor: "#fff"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M189.479,30.32s40.953.363,62.045,32.746c21.4,32.858,39.307,113.437-72.4,154.449C67.7,258.421,15.838,150.9,10.668,138.006s-32.34-81.981,27.19-121.819C99.04-24.756,92.727,24.137,189.479,30.32Z",
    transform: "translate(0 0)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M39.564,144.8l1.713-.724-1.772-.534-.9-3.71-.65,3.77-1.713.627,1.726.633.789,3.764Z",
    transform: "translate(-3.42 -13.195)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M229.187,178.555l1.714-.723-1.772-.534-.9-3.71-.65,3.769-1.713.628,1.726.633.789,3.764Z",
    transform: "translate(-21.313 -16.38)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M67.712,68.153a1.292,1.292,0,1,1-1.292-1.292A1.292,1.292,0,0,1,67.712,68.153Z",
    transform: "translate(-6.145 -6.309)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(245.849 113.402)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M271.9,130.537a.434.434,0,0,1-.307-.741l4.452-4.452a.434.434,0,1,1,.613.614l-4.452,4.452A.433.433,0,0,1,271.9,130.537Z",
    transform: "translate(-271.465 -125.218)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M276.351,130.537a.432.432,0,0,1-.307-.127l-4.452-4.452a.434.434,0,1,1,.614-.614l4.452,4.452a.434.434,0,0,1-.307.741Z",
    transform: "translate(-271.465 -125.218)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(32.485 59.758)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M36.3,71.3A.434.434,0,0,1,36,70.563l4.452-4.452a.434.434,0,1,1,.613.614l-4.452,4.452a.433.433,0,0,1-.307.127Z",
    transform: "translate(-35.87 -65.984)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M40.756,71.3a.432.432,0,0,1-.307-.127L36,66.725a.434.434,0,1,1,.614-.614l4.452,4.452a.434.434,0,0,1-.307.741Z",
    transform: "translate(-35.87 -65.984)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(95.036 37.028)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M105.03,43.709a.28.28,0,0,1,.173-.488l4.057-.213a.28.28,0,1,1,.029.559l-4.057.213a.279.279,0,0,1-.2-.072Z",
    transform: "translate(-104.937 -41.086)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M107.365,45.431a.279.279,0,0,1-.092-.193l-.213-4.057a.28.28,0,0,1,.559-.029l.213,4.057a.28.28,0,0,1-.467.223Z",
    transform: "translate(-105.138 -40.886)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.475 0.475)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M105.463,41.984a.28.28,0,0,1,.459-.238l3.106,2.618a.28.28,0,0,1-.361.428l-3.106-2.618A.279.279,0,0,1,105.463,41.984Z",
    transform: "translate(-105.462 -41.436)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M105.733,44.821a.279.279,0,0,1,.065-.2l2.618-3.106a.28.28,0,0,1,.428.361l-2.618,3.106a.28.28,0,0,1-.493-.157Z",
    transform: "translate(-105.488 -41.411)"
  })))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M244.222,80.284l2.728-1.151-2.821-.851L242.7,72.376l-1.035,6-2.727,1,2.749,1.007,1.256,5.993Z",
    transform: "translate(-22.546 -6.829)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M63.644,115.438a1.07,1.07,0,1,1-1.07-1.07A1.07,1.07,0,0,1,63.644,115.438Z",
    transform: "translate(-5.803 -10.792)"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(57.666 11.793)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 38.907)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M63.674,212.1c9.6-26.962,24.334-14.647,49.147-11.7,16.423,1.95,27.567.042,38.874-9.212,12.365-10.118,18.889-23.819,19.389-40.721a70.358,70.358,0,0,0-3.006-22.583l1.989-.691a71.076,71.076,0,0,1,3.123,23.263c-.345,12.081-4.122,29.237-20.162,42.363-12,9.819-23.594,11.664-40.455,9.672-23.1-2.729-37.948-14.249-46.982,11.132Z",
    transform: "translate(-63.674 -62.702)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M7.363,0H49.952a7.363,7.363,0,0,1,7.363,7.363V48.6a7.363,7.363,0,0,1-7.363,7.363H7.363A7.363,7.363,0,0,1,0,48.6V7.363A7.363,7.363,0,0,1,7.363,0Z",
    transform: "matrix(0.782, 0.624, -0.624, 0.782, 85.342, 0)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(22.55 44.597)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "g",
    width: 43.513,
    height: 55.883,
    transform: "matrix(0.782, 0.624, -0.624, 0.782, 66.634, 0.559)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M163.058,63.651c-.52.651-.062,1.629.35,2.353,2.364,4.159,6.141,8.172,12.147,12.966,7.755,6.19,13.737,9.882,19.453,10.184l-31.949-25.5Z",
    transform: "translate(-95.58 -62.396)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "h",
    width: 16.142,
    height: 21.007,
    transform: "matrix(0.782, 0.624, -0.624, 0.782, 32.061, 43.853)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 16.142,
    height: 1.535,
    transform: "matrix(0.782, 0.624, -0.624, 0.782, 18.955, 60.271)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M104.837,158.578l-12.616-10.07,13.246-18.493a.8.8,0,0,1,1.146-.159L119.7,140.3a.8.8,0,0,1,.1,1.154Z",
    transform: "translate(-88.918 -68.627)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M88.876,147.163a.8.8,0,0,1-.217-.983c1.015-2.027,4.678-8.351,8.855-3.683,4.925,5.5,4.716,15.326,4.716,15.326Z",
    transform: "translate(-88.574 -69.677)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "k",
    width: 16.142,
    height: 21.007,
    transform: "matrix(-0.782, -0.624, 0.624, -0.782, 52.981, 87.432)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 16.142,
    height: 1.535,
    transform: "matrix(-0.782, -0.624, 0.624, -0.782, 52.024, 88.632)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M115.861,167.388l12.616,10.07,15.094-17.011a.8.8,0,0,0-.1-1.16l-13.087-10.447a.8.8,0,0,0-1.14.154Z",
    transform: "translate(-91.149 -70.418)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M131.714,181.913a.8.8,0,0,0,1.006-.006c1.751-1.439,7.107-6.413,1.63-9.452-6.457-3.583-15.99-1.2-15.99-1.2Z",
    transform: "translate(-91.384 -72.476)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M182.382,136.394l16.02,1.986,3.426-19.766a.8.8,0,0,0-.692-.933l-17.187-2.131Z",
    transform: "translate(-97.425 -67.293)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 16.142,
    height: 0.658,
    transform: "translate(100.895 71.741) rotate(-172.936)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M196.553,150.872l1.19-9.6L186.5,139.881h0l-4.777-.592-.009.073-4.675,4.244a2.369,2.369,0,0,0,3.184,3.508l.6-.542-.573,4.622a5.2,5.2,0,0,0,4.519,5.8l3.4.421a7.523,7.523,0,0,0,8.391-6.54Z",
    transform: "translate(-96.848 -69.533)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M200.462,117.445a3.778,3.778,0,0,0,.14-3.135l-15.208,1.267Z",
    transform: "translate(-97.71 -67.176)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M199.113,96.089l-14.921,15.323.21,2.519,16.086-1.34Z",
    transform: "translate(-97.596 -65.457)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M198.21,92.858a2.582,2.582,0,0,1,.875,2.927l-14.921,15.323-.274-.31Z",
    transform: "translate(-97.568 -65.152)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M120.653,87.247l-5.361-15.226,18.575-7.566a.806.806,0,0,1,1.064.479l5.75,16.332Z",
    transform: "translate(-91.095 -62.466)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 16.142,
    height: 0.658,
    transform: "matrix(0.332, 0.943, -0.943, 0.332, 24.197, 9.554)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M104.009,76.268l9.122-3.212,3.762,10.685h0l1.6,4.541-.069.024-3.148,5.473a2.369,2.369,0,0,1-4.107-2.362l.4-.7-4.393,1.547a5.2,5.2,0,0,1-6.629-3.177l-1.136-3.227A7.523,7.523,0,0,1,104.009,76.268Z",
    transform: "translate(-89.556 -63.284)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M137.331,65.9a3.778,3.778,0,0,1,3.033-.806l2.009,15.128Z",
    transform: "translate(-93.174 -62.527)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M157.094,62.694,145.311,80.542l-2.505.332-2.126-16Z",
    transform: "translate(-93.49 -62.306)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M160.623,62.883a2.582,2.582,0,0,0-3.046-.23L145.793,80.5l.361.2Z",
    transform: "translate(-93.973 -62.265)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 28.424,
    height: 16.557,
    rx: 5.101,
    transform: "matrix(0.782, 0.624, -0.624, 0.782, 63.411, 16.69)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "d",
    width: 26.757,
    height: 15.09,
    rx: 4.438,
    transform: "matrix(0.782, 0.624, -0.624, 0.782, 63.605, 17.784)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s",
    d: "M160.825,93.635a2.468,2.468,0,1,1-.389-3.468A2.468,2.468,0,0,1,160.825,93.635Z",
    transform: "translate(-94.976 -64.847)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "s",
    width: 12.506,
    height: 1.25,
    rx: 0.486,
    transform: "matrix(0.782, 0.624, -0.624, 0.782, 71.984, 26.931)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "s",
    width: 12.506,
    height: 1.25,
    rx: 0.486,
    transform: "matrix(0.782, 0.624, -0.624, 0.782, 70.425, 28.884)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "s",
    width: 12.506,
    height: 1.25,
    rx: 0.486,
    transform: "matrix(0.782, 0.624, -0.624, 0.782, 68.866, 30.837)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "s",
    width: 12.506,
    height: 1.25,
    rx: 0.486,
    transform: "matrix(0.782, 0.624, -0.624, 0.782, 67.306, 32.791)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "s",
    width: 12.506,
    height: 1.25,
    rx: 0.486,
    transform: "matrix(0.782, 0.624, -0.624, 0.782, 65.747, 34.744)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M147.271,81.938l5.61,4.478-1.314,1.646-5.61-4.478a1.011,1.011,0,0,1-.1-1.423h0A1.011,1.011,0,0,1,147.271,81.938Z",
    transform: "translate(-93.956 -64.104)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M182.163,112.538l-5.491-4.383,1.314-1.646,5.491,4.383a1,1,0,0,1,.08,1.411h0a1,1,0,0,1-1.393.235Z",
    transform: "translate(-96.887 -66.44)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "t",
    d: "M168.264,119,138.415,95.178c-4.064-3.244-6.982.684-10.745,5.4h0c-3.763,4.714-6.947,8.43-2.883,11.674l29.849,23.826c4.064,3.244,6.981-.684,10.744-5.4h0C169.144,125.964,172.328,122.248,168.264,119Z",
    transform: "translate(-91.812 -65.259)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(85.411 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "u",
    cx: 29.339,
    cy: 29.339,
    r: 29.339,
    transform: "translate(0 20.132) rotate(-20.066)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "v",
    cx: 22.963,
    cy: 28.093,
    rx: 22.963,
    ry: 28.093,
    transform: "matrix(0.624, -0.782, 0.782, 0.624, 0.052, 39.662)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "b",
    cx: 22.371,
    cy: 27.369,
    rx: 22.371,
    ry: 27.369,
    transform: "matrix(0.624, -0.782, 0.782, 0.624, 0.988, 39.65)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "t",
    d: "M196.751,37.76c.832-2.42-1.44-4.344-5.665-3.98s-6.917,1.82-6.577,3.792c.461,2.672,1.949,3.814,6.132,3.037C193.229,40.127,195.874,40.311,196.751,37.76Z",
    transform: "translate(-160.485 -14.976)"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(145.886 205.757)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M161.521,232.515a.434.434,0,0,1-.307-.741l4.452-4.452a.434.434,0,0,1,.614.614l-4.452,4.452a.433.433,0,0,1-.307.127Z",
    transform: "translate(-161.087 -227.195)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M165.973,232.515a.431.431,0,0,1-.307-.127l-4.452-4.452a.434.434,0,0,1,.614-.614l4.452,4.452a.434.434,0,0,1-.307.741Z",
    transform: "translate(-161.087 -227.195)"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "w",
    d: "M193.855,68.6l.746.2-.446-.625.648-1.446L193.633,67.8l-.722-.229.407.647-.7,1.436Z",
    transform: "translate(-18.176 -6.296)"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    className: "x",
    transform: "translate(157.079 47.718)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M173.7,55.854a.258.258,0,0,1-.182-.441l2.648-2.648a.258.258,0,0,1,.365.365l-2.648,2.648a.258.258,0,0,1-.183.076Z",
    transform: "translate(-173.445 -52.69)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M176.351,55.854a.257.257,0,0,1-.182-.076l-2.648-2.648a.258.258,0,1,1,.365-.365l2.648,2.648a.258.258,0,0,1-.182.441Z",
    transform: "translate(-173.445 -52.69)"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "y",
    d: "M204.039,64.767l1.078.286-.644-.9.936-2.088-1.692,1.549-1.043-.331.587.934-1.007,2.075Z",
    transform: "translate(-19.085 -5.856)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyStatesIllustrationError);
export default __webpack_public_path__ + "static/media/empty-states_illustration_error.7dd5f5210e5db97495287df8ba81cdad.svg";
export { ForwardRef as ReactComponent };